import React, { useState, useEffect, useMemo } from 'react';
import { ImagePlaceholder, TextPlaceholder } from '@depict-ai/react-ui';
import selectAnalytics from './selectAnalytics';
import Price from '../Product/Price';
import { productImageSizeTranslation } from '../../utils/image';
import { translate, prefix, translateObjectData } from '../../utils/locale';
import { baseName } from '../../utils/string';
import s from './ProductItem.scss';

const DepictItem = ({ display = {}, Link, variation = '', toggleFavourite, listItemCache, currentView = '', isCategory = false, favourites = [], setup = {} }) => {
	const [itemCache, setItemCache] = useState({});
	const productItemClasses = [s.productItem, 'u_productItem', s.productItem__depict];
	const variantToShow = useMemo(() => display?.variant_displays?.[display?.variant_index] || {}, [display]);
	const soldOutText = itemCache?.soldOut?.[setup.language] ? itemCache.soldOut[setup.language] : translate(setup, 'soldOut');
	const extraData = {};

	useEffect(() => {
		if (variantToShow.cacheData && Object.keys(itemCache).length === 0) {
			variantToShow.cacheData.then((cD) => {
				setItemCache(translateObjectData(setup, cD));
				return cD;
			}).catch(() => {
				console.log('DEBUG: unable to resolve cache data');
			});
		}
	}, [variantToShow]);

	if (!variantToShow.inStock) productItemClasses.push(s.productItem__soldOut);
	if (variantToShow.original_price) productItemClasses.push(s.productItem__sale);
	if (itemCache?.price?.newProduct) productItemClasses.push(s.productItem__new);
	if (variation) productItemClasses.push(s[`productItem__${variation}`]);

	const addToFavouritesHandler = (e) => {
		e.preventDefault();
		toggleFavourite(itemCache.groupId, 'currentPath');
	};

	const listItemSelectedHandler = () => {
		selectAnalytics(itemCache, setup, currentView, display?.variant_index);
		listItemCache(itemCache.groupId, currentView);
	};

	if (variantToShow.recommendation_id) extraData['data-recommendation-id'] = variantToShow.recommendation_id;

	return (
		<div className={productItemClasses.join(' ')} data-product-id={itemCache.groupId} {...extraData}>
			<a href="#addToFavourites" onClick={addToFavouritesHandler} className={[s.productItem_favourites, 'a-productItemFavorite'].join(' ')}>
				{ (!itemCache.groupId || favourites.indexOf(itemCache.groupId) === -1) && <span className={s.productItem_favourites_text}>{ translate(setup, 'addToFavourites') }</span> }
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="0 0 24 22">
					<path fill={!itemCache.groupId || favourites.indexOf(itemCache.groupId) === -1 ? 'none' : '#663886'} stroke="#000" strokeWidth="1.3" d="M82.3607178,44.9685735 C89.1964111,38.2322454 85.5537109,32.7345647 81.5004883,32.0919866 C78.7983398,31.6636012 76.7208802,32.7314723 75.0893698,35.2955999 C73.4578594,32.7314723 71.3803998,31.6636012 68.6782514,32.0919866 C64.6250287,32.7345647 60.9823285,38.2322454 67.8180219,44.9685735 C70.9248433,48.0302334 73.289046,50.256918 75.0893698,51.6486272 C76.8896936,50.256918 79.2538964,48.0302334 82.3607178,44.9685735 Z" transform="translate(-63 -31)" />
				</svg>
			</a>
			<Link className={s.productItem_link} onClick={listItemSelectedHandler} to={prefix(setup, `${(variantToShow.page_url || '/')}${isCategory ? `${currentView}/${(itemCache?.uri || '')}` : (itemCache?.canonicalUri || '')}`)}>
				<div className={s.productItem_images}>
					{
						variantToShow.image_urls ? (
							variantToShow.image_urls.slice(0, 2).map((image, i) => <img key={baseName(image)} {...productImageSizeTranslation('4', image, ((display?.variant_index || 1) < 4 && i === 0 ? 'eager' : 'lazy'))} alt={`${itemCache?.brand || ''} ${variantToShow.title}`} />)
						) : (
							<ImagePlaceholder aspectRatio={3 / 4} />
						)
					}
				</div>
				<div className={s.productItem_text}>
					{	itemCache?.brand ? <span className={s.productItem_text_brand}>{ itemCache.brand }</span> : <TextPlaceholder height="1em" width="20ch" /> }
					{	variantToShow.title ? <span className={s.productItem_text_name}>{ variantToShow.title }</span> : <TextPlaceholder height="1em" width="20ch" /> }
					{
						itemCache.price ? (
							<div className={s.productItem_text_price}>
								<Price price={itemCache.price} soldOut={!itemCache.inStock ? soldOutText : false} />
							</div>
						) : <TextPlaceholder height="1em" width="20ch" />
					}
				</div>
			</Link>
		</div>
	);
};

export default DepictItem;
